<script lang="ts" setup>
import { onMounted } from "vue";
import Header from "@/components/organisms/common/Header.vue";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { inAppReviewService } from "@/app/services/InAppReviewService";
import { useCustomRouter } from "@/utils/router";

const customRouter = useCustomRouter();

onMounted(async () => {
  await inAppReviewService.launchInAppReview("EXCHANGE_POINT");
});

const myPointRoute = { name: "MyPoint" };

async function onClickClose() {
  await customRouter.pushIgnoreError(myPointRoute);
}
</script>

<template>
  <div>
    <Header>
      交換申請完了
      <template v-slot:right>
        <FeatherIcon icon="x" @click="onClickClose" />
      </template>
    </Header>
    <div class="exchange-coupon-finished">
      <div class="px-3">
        <div class="text-center">
          <ExchangeCompletion />
          <p class="text-black text-size-18 text-weight-500 mt-3">
            交換申請が<br />完了しました
          </p>
        </div>
        <div class="summary-text">
          <p class="text-mild text-size-14">
            申請から3営業日以内に、登録メールアドレス宛にギフト券コードをお送りします
          </p>
        </div>
        <RouterLink :to="myPointRoute">
          <AppButtonOutline
            :block="true"
            class="text-primary-dark text-weight-500"
            >閉じる</AppButtonOutline
          >
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.exchange-coupon-finished {
  padding-top: 80px;

  .summary-text {
    padding: 40px 0;
  }
}
</style>
